import { matchRoutes } from 'react-router-dom';
import { routes } from './index';

export function routeTemplate(pathname: string): string {
  const matches = matchRoutes(routes, pathname);
  if (!matches) return `/${pathname.split('/')[1] ?? ''}`;
  const joined = `/${matches.map(match => match.route.path ?? '').join('/')}`;
  return joined.replace(/\/{2,}/g, '/').replace(/(.)\/$/, '$1');
}
